var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('apexchart',{ref:"CrmPieChart",attrs:{"height":500,"options":_vm.options,"series":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }